module.exports = __webpack_public_path__ + "img/SI-what-is@2x.9bc769f.webp";